import request from '@/utils/request'
import type {
  AddNotice,
  EditNotice,
  GetNoticeSettingByIdResponse,
  GetNoticeShowByIdResponse,
  GetPopUpNoticeShowResponse,
  SelectNoticeSettingListPage,
  SelectNoticeSettingListPageResponse,
  SelectNoticeShowListPage,
  SelectNoticeShowListPageResponse
} from './model.d'

/**
 * 公告配置:新增公告
 * @param params 请求参数
 * @backend 李发军
 */
export function addNotice(data: AddNotice) {
  return request.post({
    url: '/notice/addNotice',
    data
  })
}
/**
 * 公告配置:删除公告
 * @param id 公告id
 * @backend 李发军
 */
export function deleteNotice(id: number) {
  return request.delete({
    url: `/notice/delete/${id}`,
    data: {}
  })
}
/**
 * 公告配置:编辑公告：删除公告文件
 * @param id 文件id
 * @backend 李发军
 */
export function deleteAttachFile(id: number) {
  return request.delete({
    url: `/notice/deleteFile/${id}`,
    data: {}
  })
}
/**
 * 公告配置:编辑公告
 * @param params 请求参数
 * @backend 李发军
 */
export function editNotice(data: EditNotice) {
  return request.put({
    url: `/notice/editNotice/${data.id}`,
    data
  })
}
/**
 * 公告配置:获取公告详情信息
 * @param id 公告id
 * @backend 李发军
 */
export function getNoticeSettingById(id: number): Promise<GetNoticeSettingByIdResponse> {
  return request.get({
    url: `/notice/getNoticeSettingById/${id}`
  })
}

/**
 * 用户公告:获取用户未读公告数量
 * 1: 用户在公告之前创建，统计该用户的未读
 * 2: 用户在公告之后创建，不统计该公告的未读（将已读/未读状态设置为第三个状态-无状态：既不是已读也不是未读）
 * @backend 李发军
 */
export function getNoticeUnReadCount(): Promise<number> {
  return request.get({
    url: '/notice/getNoticeUnReadCount'
  })
}
/**
 * 用户公告-获取唯一弹窗公告，若无弹窗公告则或用户已读，则返回为空
 * @backend 周逸轩
 */
export function getPopUpNotice(): Promise<GetPopUpNoticeShowResponse> {
  return request.get({
    url: '/notice/getPopUpNotice'
  })
}
/**
 * 公告配置:开启/关闭弹窗提醒
 * @param id 公告id
 * @backend 李发军
 */
export function toggleNoticePopUp(id: number) {
  return request.put({
    url: `/notice/isPopUp/${id}`,
    data: {}
  })
}
/**
 * 公告配置:开启/关闭可见状态
 * @param id 公告id
 * @backend 李发军
 */
export function toggleNoticeShow(id: number) {
  return request.put({
    url: `/notice/isShow/${id}`,
    data: {}
  })
}
/**
 * 公告配置:开启/关闭置顶公告
 * @param id 公告id
 * @backend 李发军
 */
export function toggleNoticeTop(id: number) {
  return request.put({
    url: `/notice/isTop/${id}`,
    data: {}
  })
}
/**
 * 公告配置:公告列表
 * @param params 请求参数
 * @backend 李发军
 */
export function selectNoticeSettingListPage(
  data: SelectNoticeSettingListPage
): Promise<SelectNoticeSettingListPageResponse> {
  return request.post({
    url: '/notice/selectNoticeSettingListPage',
    data
  })
}
/**
 * 用户公告:公告列表
 * @param params 请求参数
 * @backend 李发军
 */
export function selectNoticeShowListPage(
  data: SelectNoticeShowListPage
): Promise<SelectNoticeShowListPageResponse> {
  return request.post({
    url: '/notice/selectNoticeShowListPage',
    data
  })
}

/**
 * 用户公告-标记已读
 * @param id 公告id
 * @backend 周逸轩
 */
export function markNoticeRead(id: number) {
  return request.post({
    url: `/notice/markNoticeRead/${id}`,
    data: {}
  })
}
